import Responsive from "react-responsive";
import type {
	BreakpointDefinitions,
	BreakpointProps,
} from "./breakpoints.types";

export const Breakpoint = ({
	up = false,
	down = false,
	minWidth,
	maxWidth,
	children,
	...props
}: BreakpointProps) => {
	if (!children) {
		return null;
	}
	return (
		<Responsive
			{...props}
			maxWidth={up ? undefined : maxWidth}
			minWidth={down ? undefined : minWidth}
		>
			{children}
		</Responsive>
	);
};

export const createBreakpointComponents = (
	breakpoints: BreakpointDefinitions,
) => ({
	MobileBreakpoint: (props: BreakpointProps) => (
		<Breakpoint maxWidth={breakpoints.mobile} {...props} />
	),
	TabletBreakpoint: (props: BreakpointProps) => (
		<Breakpoint
			minWidth={breakpoints.mobile + 1}
			maxWidth={breakpoints.tablet}
			{...props}
		/>
	),
	DesktopBreakpoint: (props: BreakpointProps) => (
		<Breakpoint
			minWidth={breakpoints.tablet + 1}
			maxWidth={breakpoints.desktop}
			{...props}
		/>
	),
	XLDesktopBreakpoint: (props: BreakpointProps) => (
		<Breakpoint minWidth={breakpoints.desktop + 1} {...props} />
	),
});

export default Breakpoint;
